/**
 * on/off mixin
 */

/**
 * onOffMixinFactory
 * returns onOffMixin mixin factory
 *
 * @class onOffMixinFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Object} {@link models.onOffMixin} mixin
 *
 * @ngdoc factory
 * @name mwApp.factory:onOffMixinFactory
 */
/* @ngInject */
export default function onOffMixinFactory ($http, alertLiteSvc) {
  var on = '"ENABLE"'
  var off = '"DISABLE"'

  /**
   * Mixin for enabling and disabling Entities
   *
   * @mixin onOffMixin
   * @memberof models
   * @see models
   * @type {Object}
   */
  var onOffMixin = {

    /**
     * On/Off Entity, performing PATCH request to the server
     *
     * @memberof models.onOffMixin#
     * @param {Boolean} [enabled=this.enabled] - enable or disable Entity
     * @param {String} status
     * @return {Promise} promise
     */
    _onOff: function (enabled, status) {
      if (typeof enabled !== 'boolean') {
        enabled = this.enabled
      }
      const payload = status || (enabled ? on : off)

      return $http.patch(this._url, payload)
        .then(
          response => {
            if (response.data) {
              this._weakCopy(response.data)
            }
            return response
          }
        ).catch(
          rejection => {
            this.enabled = !this.enabled
            return alertLiteSvc.alertError(rejection)
          }
        )
    }
  }

  return onOffMixin
}
